// extracted by mini-css-extract-plugin
export default {"editable":"styles_editable__UJNO9","input":"styles_input__LyTUe"};